import React, { FC } from 'react';
import './index.scss';
import { StaticImage } from 'gatsby-plugin-image';

const hours = [
  {
    day: 'monday',
    hours: '9am - 7pm',
  },
  {
    day: 'tuesday',
    hours: '9am - 7pm',
  },
  {
    day: 'wednesday',
    hours: '9am - 7pm',
  },
  {
    day: 'thursday',
    hours: '9am - 7pm',
  },
  {
    day: 'friday',
    hours: '9am - 7pm',
  },
  {
    day: 'saturday',
    hours: '8am - 4pm',
  },
  {
    day: 'sunday',
    hours: 'closed',
  },
];

const isClient = typeof window !== 'undefined';

const Location = React.forwardRef<HTMLDivElement, {}>(function Location(
  {},
  ref
) {
  return (
    <section id='location-section' key='location-section' ref={ref}>
      <div className='location-container'>
        <h2
          data-sal='slide-up'
          data-sal-duration='500'
          data-sal-easing='ease-in-out'
        >
          Come Find Us
        </h2>
        <div className='location-content-container'>
          <div className='location-details'>
            <div
              className='address'
              data-sal='slide-up'
              data-sal-duration='500'
              data-sal-easing='ease-in-out'
            >
              <h3>address:</h3>
              <p>1541 bloomingdale road, glendale heights, il 60139</p>
            </div>
            <div
              className='contact'
              data-sal='slide-up'
              data-sal-duration='500'
              data-sal-easing='ease-in-out'
            >
              <div>
                <h3>phone:</h3>
                <a href='tel:6305809587'>(630) 580-9587</a>
              </div>
              <div className='social'>
                <h3>social:</h3>
                <p>
                  <button
                    className='social-button'
                    onClick={() =>
                      (location.href = 'https://www.instagram.com/onefamshop/')
                    }
                  >
                    <StaticImage
                      objectFit='contain'
                      className='instagram-logo'
                      height={20}
                      layout='fixed'
                      src='../../images/instagram-logo.png'
                      alt='instagram Logo'
                      placeholder='none'
                    />
                  </button>
                  <button
                    className='social-button'
                    onClick={() =>
                      (location.href = 'https://www.facebook.com/0NEFAMSHOP/')
                    }
                  >
                    <StaticImage
                      objectFit='contain'
                      className='facebook-logo'
                      height={32}
                      layout='fixed'
                      src='../../images/facebook-logo.png'
                      alt='Facebook Logo'
                      placeholder='none'
                    />
                  </button>
                </p>
              </div>
            </div>
            <div
              className='email'
              data-sal='slide-up'
              data-sal-duration='500'
              data-sal-easing='ease-in-out'
            >
              <h3>more info + send resume:</h3>
              <p>onefamshop@gmail.com</p>
            </div>
            <div
              className='hours'
              data-sal='slide-up'
              data-sal-duration='500'
              data-sal-easing='ease-in-out'
            >
              <h3>hours:</h3>
              <div className='hours-details'>
                {hours.map((day, index) => (
                  <div className='hour-day-details' key={`hour-row-${index}`}>
                    <div className='hour-day' key={`day-${day.day}-${index}`}>
                      {day.day}
                    </div>
                    <div key={`hours-${day.day}-${index}`}>{day.hours}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='location-map'>
            <div
              className='map'
              data-sal='slide-up'
              data-sal-duration='500'
              data-sal-easing='ease-in-out'
            >
              <iframe
                src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2968.9516888506955!2d-88.08362442404353!3d41.91539726307826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fade167b4c415%3A0xca035400674ddd36!2sONEFAM!5e0!3m2!1sen!2sus!4v1700965537355!5m2!1sen!2sus'
                width='100%'
                height='100%'
                style={{ border: '0' }}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

export default Location;
